import axios from "axios";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { useLocation, useNavigate } from "react-router";
import PopupModal from "../popupmodal/PopupModal";
import sample from "../../../csvSample/samplefile.csv";

export default function UploadCustomerComp() {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const [popupState, setPopupState] = useState({
    addData: false,
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
    reset,
  } = useForm();

  const { state } = useLocation();

  // Function to close the modal
  const closeModal = () => {
    setIsOpen(false);
    setPopupState({
      addData: false,
    });
  };
  const handleNavigate = () => {
    navigate("/uploadViewCustomer");
    setIsOpen(false);
    setPopupState({
      addData: false,
    });
    window.location.reload();
  };

  const { mutate, isLoading, isError, isSuccess } = useMutation(
    (postData) => {
      axios.post(
        `${process.env.REACT_APP_HOST}/customers/uploadcustomer`,
        postData
      );
    },
    {
      onSuccess: (data) => {
        setIsOpen(true);
        setPopupState({
          addData: true,
        });
      },
      onError: (error) => {
        console.error("Mutation failed:", error);
        reset();
      },
    }
  );
  const onSubmit = (data) => {
    const formData = new FormData();
    formData.append("file", data?.file[0]);
    if (formData) {
      mutate(formData);
    }
  };

  return (
    <>
      <div className="upload_customer_main_section">
        <a href={sample} download="sample.csv" className="sample_download">
          Sample File Download
        </a>
        <button
          className="view_customer_btn"
          onClick={() => {
            navigate("/uploadViewCustomer");
          }}
        >
          View Customer
        </button>

        <div className="upload_customer_block">
          {/* <h6 className="uploadtext">Base Name</h6>
        <input type="text" className="uploadinput" {...register("baseName")} /> */}

          <form onSubmit={handleSubmit(onSubmit)}>
            <h6 className="uploadtext my-1">Upload File</h6>
            <input
              type="file"
              className="uploadinput"
              accept=".csv"
              {...register("file", { required: true })}
            />

            {errors.file && (
              <p style={{ color: "red" }}>Please upload a file</p>
            )}

            <div>
              <button className="uploadbutton" type="submit">
                {isLoading ? <i class="fa fa-spinner fa-spin"></i> : "Submit"}
              </button>
            </div>
          </form>
        </div>
      </div>
      <PopupModal
        isOpen={isOpen}
        onClose={closeModal}
        popupState={popupState}
        message="FILE ADDED SUCCESSFULLY"
        onDone={handleNavigate}
        updateMessage="CUSTOMER HAS BEEN UPDATED SUCCESSFULLY"
        stateID={state && state?.customerId}
      />
    </>
  );
}
